export default "__VITE_ASSET__45c1e419__"